import React, { useState } from 'react';
import { Button, Collapse, Form, Card } from 'react-bootstrap';

const GradingDropdown = ({ onSave }) => {
  const [open, setOpen] = useState(false);
  const [marks, setMarks] = useState('');
  const [comments, setComments] = useState('');

  const handleSave = () => {
    onSave({ marks, comments });
    setOpen(false); // Close the dropdown after saving
  };

  return (
    <div>
      <Button
        onClick={() => setOpen(!open)}
        aria-controls="grading-form"
        aria-expanded={open}
        style={{width:'140px'}}
      >
        {open ? 'Close' : 'Grade'}
      </Button>
      <Collapse in={open}>
        <div id="grading-form" style={{width: '700px',height:'auto'}}>
          <Card style={{ marginTop: '10px' }}>
            <Card.Body>
              <Form>
                <Form.Group controlId="formMarks">
                  <Form.Label>Marks</Form.Label>
                  <Form.Control
                    type="number"
                    value={marks}
                    onChange={(e) => setMarks(e.target.value)}
                    min="0"
                    step="0.1"
                  />
                </Form.Group>
                <Form.Group controlId="formComments" style={{ marginTop: '10px' }}>
                  <Form.Label>Remarks/Comments</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                  />
                </Form.Group>
                <Button variant="primary" onClick={handleSave} style={{ marginTop: '10px' }}>
                  Save
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </Collapse>
    </div>
  );
};

export default GradingDropdown;
